(function () {
  'use strict';

  angular.module('sempraWebapp').factory('AlarmStateEnum', alarmStateEnumFactory);

  function alarmStateEnumFactory () {
    return Object.freeze({
      NORMAL: 'NORMAL',
      HIGH: 'HIGH',
      LOW: 'LOW'
    });
  }
})();
